import { render, staticRenderFns } from "./SearchAttributeFilter.vue?vue&type=template&id=96af96be"
import script from "./SearchAttributeFilter.vue?vue&type=script&lang=js"
export * from "./SearchAttributeFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports